import { cn } from '@/lib/cn';

export interface PageHeaderProps {
  readonly title: string;
  readonly description?: string | undefined;
  readonly actions?: React.ReactNode | undefined;
  readonly className?: string | undefined;
}

/**
 * The page title block. Renders the one h1 per page, which is what a screen reader user
 * jumps to first and what the route change announcement in AppShell reads.
 */
export function PageHeader({
  title,
  description,
  actions,
  className,
}: PageHeaderProps): React.JSX.Element {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-4', className)}>
      <div className="min-w-0">
        <h1 className="text-xl font-semibold tracking-tight text-fg">{title}</h1>
        {description !== undefined ? (
          <p className="mt-1 max-w-3xl text-sm text-fg-muted">{description}</p>
        ) : null}
      </div>
      {actions !== undefined ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
